/**
 * Tailwind class mappings for project types.
 */ export const PROJECT_TYPE_STYLES = {
    proposal: {
        badge: 'bg-project-type-proposal text-project-type-proposal-foreground',
        bar: 'bg-project-type-proposal',
        iconBg: 'bg-project-type-proposal/10',
        icon: 'text-project-type-proposal'
    },
    general: {
        badge: 'bg-project-type-general text-project-type-general-foreground',
        bar: 'bg-project-type-general',
        iconBg: 'bg-project-type-general/10',
        icon: 'text-project-type-general'
    },
    contract: {
        badge: 'bg-project-type-general text-project-type-general-foreground',
        bar: 'bg-project-type-general',
        iconBg: 'bg-project-type-general/10',
        icon: 'text-project-type-general'
    },
    pre_award: {
        badge: 'bg-project-type-proposal text-project-type-proposal-foreground',
        bar: 'bg-project-type-proposal',
        iconBg: 'bg-project-type-proposal/10',
        icon: 'text-project-type-proposal'
    }
};
/**
 * Human-readable labels for project types. The raw type tag (e.g. `pre_award`)
 * is not display-safe — a CSS `capitalize` only fixes the first letter and
 * leaves the underscore. Render through getProjectTypeLabel instead.
 */ export const PROJECT_TYPE_LABELS = {
    general: 'General',
    proposal: 'Proposal',
    contract: 'Contract',
    pre_award: 'Pre-Award'
};
/**
 * Get style classes for a project type with fallback to 'general'.
 */ export function getProjectTypeStyles(type) {
    return PROJECT_TYPE_STYLES[type] ?? PROJECT_TYPE_STYLES.general;
}
/**
 * Get the display label for a project type with fallback to the raw value.
 */ export function getProjectTypeLabel(type) {
    return PROJECT_TYPE_LABELS[type] ?? type;
}
